import React from "react";

export const ReloadIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="28"
        viewBox="0 0 32 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.03333 13.8333H4.51014L4.53277 13.3571C4.87222 6.21189 10.7747 0.5 18 0.5C25.4439 0.5 31.5 6.55614 31.5 14C31.5 21.4439 25.4439 27.5 18 27.5C14.6065 27.5 11.5097 26.232 9.13464 24.1534L11.7495 20.6885C13.3863 22.2203 15.5829 23.1667 18 23.1667C23.0548 23.1667 27.1667 19.0548 27.1667 14C27.1667 8.94519 23.0548 4.83333 18 4.83333C13.1825 4.83333 9.23056 8.56946 8.86813 13.2951L8.82685 13.8333H9.36667H12.3296L6.66667 21.3367L1.00378 13.8333H4.03333Z"
          fill="white"
          stroke="url(#paint0_linear_1026_35509)"
          style={{ fill: "white", fillOpacity: 1 }}
        />
        <defs>
          <linearGradient
            id="paint0_linear_1026_35509"
            x1="12.5"
            y1="3"
            x2="25"
            y2="28"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              offset="1"
              stopColor="#C32B59"
              style={{
                stopColor: "#C32B59",
                stopColor: "color(display-p3 0.7647 0.1686 0.3490)",
                stopOpacity: 1,
              }}
            />
            <stop
              offset="1"
              stopColor="#C32B59"
              style={{
                stopColor: "#C32B59",
                stopColor: "color(display-p3 0.7647 0.1686 0.3490)",
                stopOpacity: 1,
              }}
            />
            <stop
              offset="1"
              stopColor="#C12C5C"
              style={{
                stopColor: "#C12C5C",
                stopColor: "color(display-p3 0.7569 0.1725 0.3608)",
                stopOpacity: 1,
              }}
            />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
